// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-search .search-bar {
	background: #f9f9f9;
	padding: 16px;
	border-bottom: solid 1px #b2b2b2;
}

.project-search .search-wrap {
	position: relative;
}

.project-search .search-wrap .fa {
	position: absolute;
	left: 8px;
	top: 8px;
	color: #8e8e92;
	font-size: 17px;
}

.project-search .search-bar input {
	width: 100%;
	box-sizing: border-box;
	height: 36px;
	border-radius: 5px;
	border: none;
	background: #e8e8e9;
	font-size: 17px;
	padding-left: 30px;
}

.project-search .project {
	cursor: pointer;
	border-bottom: solid 1px #c7c7cb;
}

.project-search .project .project-header {
	position: relative;
	height: 92px;
	padding-left: 92px;
	padding-right: 16px;
}

.project-search .project .project-header .project-brand {
	position: absolute;
	left: 16px;
	top: 16px;
	width: 60px;
	height: 60px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
	display: inline-block;
}

.project-search .project .project-header .project-info {
	display: table-cell;
	height: 92px;
	vertical-align: middle;
}

.project-search .project .project-header .project-info .project-name {
	font-size: 17px;
	font-weight: bold;
}

.project-search .project .project-header .project-info .project-organization {
	font-size: 12px;
	color: #9A9A9A;
}

.project-search .project .project-description {
	padding: 16px;
	color: #9A9A9A;
	font-size: 12px;
	padding-top: 0px;
}

.project-search .project .project-feature {
	font-weight: bold;
	padding: 16px;
	padding-top: 0;
}

.project-search .project:last-child {
	border-bottom: none;
}

.project-search .no-results {
	padding: 16px;
	font-size: 17px;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Views/ProjectSearch.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,aAAa;CACb,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,WAAW;CACX,YAAY;CACZ,wBAAwB;CACxB,4BAA4B;CAC5B,kCAAkC;CAClC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,aAAa;CACb,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,eAAe;AAChB","sourcesContent":[".project-search .search-bar {\n\tbackground: #f9f9f9;\n\tpadding: 16px;\n\tborder-bottom: solid 1px #b2b2b2;\n}\n\n.project-search .search-wrap {\n\tposition: relative;\n}\n\n.project-search .search-wrap .fa {\n\tposition: absolute;\n\tleft: 8px;\n\ttop: 8px;\n\tcolor: #8e8e92;\n\tfont-size: 17px;\n}\n\n.project-search .search-bar input {\n\twidth: 100%;\n\tbox-sizing: border-box;\n\theight: 36px;\n\tborder-radius: 5px;\n\tborder: none;\n\tbackground: #e8e8e9;\n\tfont-size: 17px;\n\tpadding-left: 30px;\n}\n\n.project-search .project {\n\tcursor: pointer;\n\tborder-bottom: solid 1px #c7c7cb;\n}\n\n.project-search .project .project-header {\n\tposition: relative;\n\theight: 92px;\n\tpadding-left: 92px;\n\tpadding-right: 16px;\n}\n\n.project-search .project .project-header .project-brand {\n\tposition: absolute;\n\tleft: 16px;\n\ttop: 16px;\n\twidth: 60px;\n\theight: 60px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center center;\n\tdisplay: inline-block;\n}\n\n.project-search .project .project-header .project-info {\n\tdisplay: table-cell;\n\theight: 92px;\n\tvertical-align: middle;\n}\n\n.project-search .project .project-header .project-info .project-name {\n\tfont-size: 17px;\n\tfont-weight: bold;\n}\n\n.project-search .project .project-header .project-info .project-organization {\n\tfont-size: 12px;\n\tcolor: #9A9A9A;\n}\n\n.project-search .project .project-description {\n\tpadding: 16px;\n\tcolor: #9A9A9A;\n\tfont-size: 12px;\n\tpadding-top: 0px;\n}\n\n.project-search .project .project-feature {\n\tfont-weight: bold;\n\tpadding: 16px;\n\tpadding-top: 0;\n}\n\n.project-search .project:last-child {\n\tborder-bottom: none;\n}\n\n.project-search .no-results {\n\tpadding: 16px;\n\tfont-size: 17px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
